<template>
    <v-bottom-sheet
        :value="!cookiesAccepted"
        persistent
        :overlay-opacity="0.2"
    >
        <v-sheet class="pa-5" color="blue-grey darken-4" dark>
            <v-row align="center">
                <v-col cols="12" class="body-2">
                    We use cookies and similar technologies to give you the
                    best experience in our app, like remembering your details when
                    you place an order.
                </v-col>
                <v-col class="text-center" cols="12">
                    <v-btn class="primary" depressed @click="acceptCookies">Got it!</v-btn>
                </v-col>
            </v-row>
        </v-sheet>
    </v-bottom-sheet>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'PromptCookieConsent',

  computed: {
    ...mapGetters([
      'cookiesAccepted',
    ]),
  },

  methods: {
    ...mapActions([
      'acceptCookies',
    ]),
  },
};
</script>

<style scoped>

</style>
